import { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import ConfirmPopup from '../Popups/ConfirmPopup'
import { setShopProducts } from '../../reducers/shopReducer'

import StoreBlock from './StoreBlock'
import StoreBanner from './StoreBanner'
import StoreGift from './StoreGift'
import API from './../../api/api'

const getCategoryImage = (category) => {
  switch (category) {
    case 'personal-training':
      return '/images/personal-training.jpg'
    case 'massage-therapy':
      return '/images/massage-therapy.jpg'
    case 'group-training':
      return '/images/group-training.jpg'
    case 'nutrition-services':
      return '/images/nutrition.jpg'
    case 'product':
      return '/images/product.jpg'
    default:
      return '/images/personal-training.jpg'
  }
}
const mapStateToProps = (store) => ({
  products: store.shop.products,
  categories: store.shop.categories,
})

const mapDispatchToProps = {
  setProducts: setShopProducts,
}

class Store extends Component {
  constructor(props) {
    super(props)
    this.state = {
      assessmentPopupOpen: false,
      assessmentPopupBody: '',
      assessmentPopupSent: false,
      assessmentLoading: false,
    }
    this.openAssessmentPopup = this.openAssessmentPopup.bind(this)
    this.closeAssessmentPopup = this.closeAssessmentPopup.bind(this)
    this.confirmAssessment = this.confirmAssessment.bind(this)
  }

  componentDidMount() {
    API.getAllProducts()
      .then(this.props.setProducts)
      .catch((e) => {
        throw new Error(e)
      })
  }

  openAssessmentPopup() {
    this.setState({ assessmentPopupOpen: true })
  }

  closeAssessmentPopup() {
    this.setState({ assessmentPopupOpen: false })
  }

  confirmAssessment() {
    this.setState({ assessmentLoading: true, assessmentPopupBody: '' })
    API.getAssessment()
      .then(() => {
        this.setState({
          assessmentPopupSent: true,
          assessmentPopupBody: this.props.t('store:assessmentPopup.successBody', {
            email: 'contact@elevatedliving.com',
          }),
        })
      })
      .catch(() => {
        this.setState({
          assessmentLoading: false,
          assessmentPopupBody: this.props.t('store:assessmentPopup.errorBody'),
        })
      })
  }

  render() {
    const { categories, t } = this.props
    const { assessmentPopupOpen, assessmentPopupBody, assessmentPopupSent, assessmentLoading } =
      this.state
    return (
      <div
        className={`ctp-store ${
          this.props.children !== null ? 'ctp-store--' + this.props.children.type.displayName : ''
        }`}
      >
        <span className="ctp-store__bg" />
        <div className="ctp-store__inner">
          <div className="container">
            {this.props.children !== null && this.props.children}
            {this.props.children === null && (
              <div>
                <div className="columns is-multiline">
                  {categories &&
                    categories.map((c) => {
                      if (c.categoryUrl === 'gift') return ''
                      return (
                        <Link
                          key={c.categoryUrl}
                          to={`/dashboard/store/category/${c.categoryUrl}`}
                          className={`column is-6`}
                        >
                          <StoreBlock
                            title={c.categoryName}
                            image={getCategoryImage(c.categoryUrl)}
                          />
                        </Link>
                      )
                    })}
                </div>
                <div className="columns">
                  <Link
                    className={'column is-2'}
                    to={`/dashboard/store/category/gift/product/gift`}
                  >
                    <StoreGift title={t('store:giftCards')} />
                  </Link>
                  <StoreBanner
                    classes={'column is-10'}
                    title={t('store:banner.title')}
                    btnText={t('store:banner.bookNow')}
                    icon={'weight'}
                    onClick={(e) => {
                      e.preventDefault()
                      this.openAssessmentPopup()
                    }}
                  />
                </div>
                <ConfirmPopup
                  className={`modal--assessment is-success ${assessmentPopupSent ? 'is-sent' : ''}`}
                  isOpen={assessmentPopupOpen}
                  title={t('store:assessmentPopup.title')}
                  body={assessmentPopupBody}
                  confirmText={t('store:assessmentPopup.confirmText')}
                  confirmCallback={this.confirmAssessment}
                  cancelText={t('common:actions.cancel')}
                  cancelCallback={this.closeAssessmentPopup}
                  isLoading={assessmentLoading}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

Store.propTypes = {
  children: PropTypes.object,
  categories: PropTypes.array,
  products: PropTypes.array,
  setProducts: PropTypes.func,
  t: PropTypes.func,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(['store', 'common'])(Store))
